import type { HeaderModal } from '@pp/core/src/store/slices/header/types';

import type { ChartsDataType } from '../../../api/chartsData';
import type { GameConfigData } from '../../../api/gameConfigData/types';
import type { LastGameDataType } from '../../../api/lastGameData/types';
import type { RecentResultsType } from '../../../api/recentResults';
import { useGameSelector } from '../../GameStore';

import { KeyPadObjectType, LeaderBoardType } from './types';

export const useHighflyerGameStateSlice = {
  recentResults: (): RecentResultsType | null => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.recentResults);
  },
  getTableStatsResult: (): RecentResultsType | null => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.tableStatsResult);
  },
  getIsLastResultDataFetched: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.isLastResultDataFetched);
  },
  recentResultsCount: (): number => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.recentResultsCount);
  },
  timerInPlayBtnStatus: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.showTimerInPlayBtn);
  },
  chartsData: (): ChartsDataType | null => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.chartsData);
  },
  getGameConfig: (): GameConfigData | null => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.gameConfigData);
  },
  tableTopData: (): any => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.tableTopData);
  },
  lastGameData: (): LastGameDataType | null => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.lastGameData);
  },
  getIsLoadingPreviousGameData: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.loadingPreviousGameData);
  },
  getIsLoadMorePreviousGameData: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.loadMorePreviousGameData);
  },
  leaderBoardHistory: (): LeaderBoardType | null => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.leaderBoardHistory);
  },
  getIsApiRejected: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.isApiRejected);
  },
  getIsLoadingTopData: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.isLoadingTopData);
  },
  currentTopTab: (): string => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.currentTopTab);
  },
  isTabScrollbarAtTop: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.isTabScrollbarAtTop);
  },
  toggleStats: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.toggleStats);
  },
  currentCalenderOption: (): string => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.currentCalenderOption);
  },
  toggleKeypad: (): KeyPadObjectType => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.toggleKeypad);
  },
  getJackpot: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.jackpot);
  },
  getChatClosed: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.isChatClosed);
  },
  getSelectedHeader: (): HeaderModal | null => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.selectedHeader);
  },
  getAnimationToggle: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.settings.isAnimationToggle);
  },
  getIsSecondBetBoardToggle: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.settings.isSecondBetBoardToggle);
  },
  getHfHideMyBets: (): boolean => {
    return useGameSelector(({ highflyerGameState }) => highflyerGameState.settings.hfHideMyBets);
  },
};
